import fetchMock from "fetch-mock";
import Auth from "@aws-amplify/auth";
import constants from "@/constants";
const baseURL: string = process.env.VUE_APP_API_URL || "";

export const mockRequest = async (config: FetchConfig): Promise<void> => {
  const { url = "", mockedResponse = {}, method } = config;
  console.info(`Mocked ${method}: ${url}`);

  await fetchMock.mock(url, mockedResponse, {
    delay: 500
  });
};

export const fetchRequest = async (
  config: FetchConfig
): Promise<UnknownObj> => {
  const { url = "", headers: addedHeaders, mockedResponse } = config;
  let { body = undefined, method = "GET" } = config;
  const { mode } = config;

  const headers = new Headers();
  headers.append("Content-Type", "application/json");

  if (addedHeaders) {
    Object.keys(addedHeaders).forEach(key => {
      headers.append(key, addedHeaders[key]);
    });
  }

  let jwtToken;

  await Auth.currentSession()
    .then((session: UnknownObj) => {
      jwtToken = session?.idToken?.jwtToken as string;
      if (jwtToken) {
        localStorage.setItem("jwtToken", jwtToken);
      }
    })
    .catch(() => null);

  if (!jwtToken) {
    jwtToken = localStorage.getItem("jwtToken");
  }

  if (jwtToken) {
    // Set auth header on all requests
    headers.append("authorization", `Bearer ${jwtToken}`);
  }

  let requestUrl = baseURL;
  if (url.indexOf("http") === 0 || url.indexOf("//") === 0) {
    requestUrl = url;
  } else {
    requestUrl = `${baseURL}${url}`;

    // removes double // from requests
    if (url[0] === "/") {
      requestUrl = requestUrl.replace(`/${url}`, url);
    }
  }

  method = method.toUpperCase();
  if (!["GET", "POST", "PUT", "DELETE", "OPTIONS", "PATCH"].includes(method)) {
    method = "GET";
  }

  if (body) {
    body = JSON.stringify(body);
  }

  fetchMock.restore();

  if (mockedResponse) {
    await mockRequest({ url: requestUrl, mockedResponse, method });
  }

  const requestInit = {
    method,
    headers,
    body,
    mode
  } as RequestInit;

  return fetch(requestUrl, requestInit).then(async response => {
    if ([200, 201].includes(response.status)) {
      return response.json ? await response.json() : response || {};
    } else {
      if ([204].includes(response?.status)) {
        return {};
      }

      const errors =
        ((response.json ? await response.json() : response) || {}).errors || [];

      const errCode = errors?.[0]?.code || "0";

      const error: FetchError = {
        status: response?.status || 500,
        errors,
        code: errCode,
        statusText:
          (constants as UnknownObj)[errCode] ||
          errors?.[0]?.message ||
          response?.statusText ||
          constants.CONN_ERROR
      };

      throw error;
    }
  });
};
